// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"c23dd13f","455":"346d1686","977":"0c695b50"}[chunkId] + ".chunk.js";
};